module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.text) ? _c('div', {
    class: [_vm.block]
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b96cd79a","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/InputLabel.vue
// module id = 422
// module chunks = 0